// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackModal-cls1_1B0","cls2":"FeedbackModal-cls2_fMR FeedbackModal-cls1_1B0"};